export class genericCustomError extends Error {
	cause?: unknown;

	constructor(message: string, cause?: unknown) {
		super(message);
		this.name = 'genericCustomError';
		this.cause = cause;
		Object.setPrototypeOf(this, genericCustomError.prototype);
	}
}


export class ECUCSelectDataProcessError extends genericCustomError {
    constructor(message: string, cause?: unknown) {
        super(message, cause);
        this.name = 'ECUCSelectDataProcessError';
        Object.setPrototypeOf(this, ECUCSelectDataProcessError.prototype);
    }
}
